import React from 'react';
import PropTypes from 'prop-types';
import {Text} from '../atoms/Text';
import {withMetrics, trackException} from '../metrics';

const ErrorPage = ({error}) => {
  trackException(error);
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        flexDirection: 'column',
      }}
    >
      <Text>Sorry for the inconvenience.</Text>
      <Text style={{marginTop: '14px', maxWidth: '510px', textAlign: 'center'}}>
        {error.specific ? error.error : `
        Unfortunately we are not able to fetch the data you requested. Please
        try again in 5 - 15 minutes. It could be that we are updating our data
        warehouse.
        `}
      </Text>
    </div>
  );
};

ErrorPage.propTypes = {
  error: PropTypes.object,
};

export default withMetrics(ErrorPage, 'ErrorPage');
